import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Termsandconditions() {
  return (
           <div >
       <Header /> 
     <div className='app_header_height'></div>
    <div className="container_roots">
  
    <Helmet>
        <title>Terms and Conditions | EditorTask</title>
        <meta name="description" content="Read the terms and conditions for using EditorTask, a trusted platform to post jobs, showcase talent, and connect with employers across India." />
        <meta name="keywords" content="terms and conditions, user agreement, editor task policy, freelance job terms, job seeker terms, employer terms" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Terms and Conditions | EditorTask" />
        <meta property="og:description" content="Understand the legal agreement and responsibilities of using EditorTask. Explore how we support freelancers and employers in India." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/terms" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>

      <div className="container_size">
        <h2 className="contact-title">Terms & Conditions</h2>
        <div className="terms-text">

          <p><strong>Welcome to EditorTask!</strong></p>
          <p>By accessing our platform, you agree to the following terms and conditions. Please read them carefully before using our services.</p>

          <h2>1. Introduction</h2>
          <p>EditorTask connects job seekers, editors, and creative professionals with employers and clients. By using our services, you agree to comply with our terms and policies.</p>

          <h2>2. Account Creation</h2>
          <p>You must provide accurate information while creating your profile. Fake or misleading details can result in account suspension or termination.</p>

          <h2>3. Use of Services</h2>
          <ul>
            <li>You may use the platform to post or apply for jobs, upload portfolios, and connect with users.</li>
            <li>Any misuse, spam, or unauthorized activity is strictly prohibited.</li>
            <li>You are responsible for the content you share and the jobs/tasks you apply for or post.</li>
          </ul>

          <h2>4. Intellectual Property</h2>
          <p>All content posted by users remains their intellectual property. However, by uploading to EditorTask, you grant us a license to display your work on the platform.</p>

          <h2>5. Payments & Fees</h2>
          <p>Transactions between users (job providers and editors) are subject to individual agreements. EditorTask may offer optional payment services, which are governed by additional terms.</p>

          <h2>6. Privacy</h2>
          <p>We value your privacy. Your data will not be sold to third parties. Refer to our <a href="/privacy-policy">Privacy Policy</a> for more details.</p>

          <h2>7. Modifications</h2>
          <p>EditorTask reserves the right to modify these terms at any time. Users will be notified of significant changes.</p>

          <h2>8. Termination</h2>
          <p>We reserve the right to suspend or terminate any account that violates our terms or engages in suspicious activity.</p>

          <h2>9. Contact Us</h2>
          <p>If you have questions about these terms, please email us at <a href="mailto:support@editortask.com">support@editortask.com</a>.</p>

        </div>
      </div>
      </div>
</div>
    );
}
